// src/hooks/useGameEndSender.ts
import { useEffect, useRef } from 'react';
import { MatchState } from '../types';
import { generateGameEndJSON, sendResultsToCallback } from './useResultSender';

interface UseGameEndSenderProps {
  matchState: MatchState;
  enabled?: boolean;
}

export function useGameEndSender({ matchState, enabled = true }: UseGameEndSenderProps) {
  const prevGameResultsLength = useRef(matchState.gameResults.length);
  
  useEffect(() => {
    console.log('🔍 [useGameEndSender] Hook effect triggered:', {
      enabled,
      hasCallbackUrl: Boolean(matchState.matchInfo.resultCallbackUrl),
      callbackUrl: matchState.matchInfo.resultCallbackUrl,
      currentGamesLength: matchState.gameResults.length,
      prevGamesLength: prevGameResultsLength.current,
      matchEnded: matchState.matchEnded
    });

    // Conditions de déclenchement
    if (!enabled || !matchState.matchInfo.resultCallbackUrl) {
      //console.log('⏭️ [useGameEndSender] Skip: disabled ou pas d\'URL');
      return;
    }
    
    const currentLength = matchState.gameResults.length;
    
    // Seulement si un nouveau jeu a été ajouté ET ce n'est pas un rollback ET le match n'est pas terminé
    if (currentLength > prevGameResultsLength.current && currentLength > 0 && !matchState.matchEnded) {
      //('🎯 [useGameEndSender] Nouveau jeu détecté! Envoi en cours...');
      sendGameEndUpdate();
    }
    
    prevGameResultsLength.current = currentLength;
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [matchState.gameResults.length, enabled, matchState.matchInfo.resultCallbackUrl, matchState.matchEnded]);
  // sendGameEndUpdate omis des dépendances car défini dans le scope et appelé conditionnellement

  const sendGameEndUpdate = async () => {
    try {
      //console.log('🚀 [useGameEndSender] Début envoi silencieux...');
      
      // Générer les données partielles
      const gameEndData = generateGameEndJSON(matchState);
      
      //console.log('📊 [useGameEndSender] Données générées:', gameEndData);
      
      // Envoi silencieux
      await sendResultsToCallback(gameEndData, matchState.matchInfo.resultCallbackUrl!);
      
      //console.log('✅ [useGameEndSender] Envoi silencieux réussi');
      
    } catch (error) {
      console.error('❌ [useGameEndSender] Erreur envoi silencieux:', error);
    }
  };
}